import { Box } from '@mui/material';
import * as React from 'react';

import styles from './index.module.scss';

const Loader = ({compact = false}) => (
  <Box
    className={styles.loader_container}
    sx={{
      width: compact ? 'unset !important' : '100vw',
      height: compact ? 'unset !important' : '100vh',
    }}
  >
    <Box
      className={styles.loader}
    />
  </Box>
);

export default Loader;
